import React from "react";
import "./AboutMission.css";

const AboutMission = () => {
  return (
    <section className="mv-section">
      <div className="mv-container">
        
        {/* Section Header */}
        <div className="mv-header">
          <span className="mv-subtitle">Who We Are</span>
          <h2 className="mv-title">Driving Excellence in Education</h2>
          <div className="mv-underline"></div>
        </div>

        <div className="mv-grid">
          
          {/* VISION CARD */}
          <div className="mv-card vision-card">
            <div className="mv-image-wrapper vision-img">
              {/* Decorative Overlay */}
              <div className="mv-img-overlay"></div>
            </div>
            
            <div className="mv-content-wrapper">
              <div className="mv-floating-icon icon-vision">
                {/* Eye Icon SVG */}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </div>
              
              <h3>Our Vision</h3>
              <p>
                To create a society where no disability limits potential and no daughter is deprived of education, shaping confident and responsible citizens who serve the nation with pride.
              </p>
            </div>
          </div>

          {/* MISSION CARD */}
          <div className="mv-card mission-card">
            <div className="mv-image-wrapper mission-img">
               <div className="mv-img-overlay"></div>
            </div>
            
            <div className="mv-content-wrapper">
              <div className="mv-floating-icon icon-mission">
                {/* Target/Mountain Icon SVG */}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m8 3 4 8 5-5 5 15H2L8 3z" />
                </svg>
              </div>

              <h3>Our Mission</h3>
              <p>
                To provide inclusive and quality education to students with disabilities and rural daughters, empowering them with confidence, strong values, and NCC discipline to build a successful and self-reliant future.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutMission;